class AboutHeroComponent extends HTMLElement {
  connectedCallback() {
    this.playButton = this.querySelector('[data-about-hero-play]');
    this.muteButton = this.querySelector('[data-about-hero-mute]');
    this.controls = this.querySelector('[data-about-hero-controls]');
    this.mediaQuery = window.matchMedia('(max-width: 749px)');

    this.handleMediaChange = () => {
      this.setActiveVideo();
      this.syncControlsVisibility();
      this.syncUi();
    };

    this.playButton?.addEventListener('click', () => this.togglePlayback());
    this.muteButton?.addEventListener('click', () => this.toggleMute());

    if (typeof this.mediaQuery.addEventListener === 'function') {
      this.mediaQuery.addEventListener('change', this.handleMediaChange);
    } else if (typeof this.mediaQuery.addListener === 'function') {
      this.mediaQuery.addListener(this.handleMediaChange);
    }

    this.setActiveVideo();
    this.syncControlsVisibility();
    this.syncUi();
  }

  disconnectedCallback() {
    if (this.activeVideo) {
      this.activeVideo.removeEventListener('play', this.boundSyncUi);
      this.activeVideo.removeEventListener('pause', this.boundSyncUi);
      this.activeVideo.removeEventListener('volumechange', this.boundSyncUi);
    }

    if (this.mediaQuery) {
      if (typeof this.mediaQuery.removeEventListener === 'function') {
        this.mediaQuery.removeEventListener('change', this.handleMediaChange);
      } else if (typeof this.mediaQuery.removeListener === 'function') {
        this.mediaQuery.removeListener(this.handleMediaChange);
      }
    }
  }

  setActiveVideo() {
    if (!this.boundSyncUi) {
      this.boundSyncUi = () => this.syncUi();
    }

    if (this.activeVideo) {
      this.activeVideo.removeEventListener('play', this.boundSyncUi);
      this.activeVideo.removeEventListener('pause', this.boundSyncUi);
      this.activeVideo.removeEventListener('volumechange', this.boundSyncUi);
    }

    const selector = this.mediaQuery?.matches
      ? '.about-hero__media--mobile video'
      : '.about-hero__media--desktop video';

    this.activeVideo = this.querySelector(selector);

    if (this.activeVideo instanceof HTMLVideoElement) {
      this.activeVideo.addEventListener('play', this.boundSyncUi);
      this.activeVideo.addEventListener('pause', this.boundSyncUi);
      this.activeVideo.addEventListener('volumechange', this.boundSyncUi);
    } else {
      this.activeVideo = null;
    }
  }

  syncControlsVisibility() {
    if (!(this.controls instanceof HTMLElement)) return;

    if (this.activeVideo instanceof HTMLVideoElement) {
      this.controls.hidden = false;
    } else {
      this.controls.hidden = true;
    }
  }

  syncUi() {
    if (!(this.activeVideo instanceof HTMLVideoElement)) return;

    if (this.playButton instanceof HTMLButtonElement) {
      this.playButton.setAttribute('aria-label', this.activeVideo.paused ? 'Play' : 'Pause');
    }

    if (this.muteButton instanceof HTMLButtonElement) {
      this.muteButton.setAttribute('aria-label', this.activeVideo.muted ? 'Unmute' : 'Mute');
    }
  }

  async togglePlayback() {
    if (!(this.activeVideo instanceof HTMLVideoElement)) return;

    if (this.activeVideo.paused) {
      try {
        await this.activeVideo.play();
      } catch (_) {
        this.activeVideo.pause();
      }
    } else {
      this.activeVideo.pause();
    }

    this.syncUi();
  }

  toggleMute() {
    if (!(this.activeVideo instanceof HTMLVideoElement)) return;

    this.activeVideo.muted = !this.activeVideo.muted;
    this.syncUi();
  }
}

if (!customElements.get('about-hero-component')) {
  customElements.define('about-hero-component', AboutHeroComponent);
}
